import React from 'react';

const InvitationForm = ({ email, setEmail, handleSubmit }) => {
    return (<form style={{ width: '50%', height: '70%', margin: '10%' }} onSubmit={handleSubmit} className="invitation-form">
        <div className="row">
            <div className="col-md-8">
                <input className="form-control" placeholder="email" type="email" value={email} onChange={e => setEmail(e.target.value)} aria-describedby="emailHelp" required />
                <div id="emailHelp" class="form-text">Please enter the correct email.</div>
            </div>
            <div className="col-md-4">
                <button className="btn btn-primary" type="submit">Send</button>
            </div>
        </div>
    </form>
    );
};

export default InvitationForm;